import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Styles/Header.css";
import logo from "../../Asserts/Stallforom.png";
import Electric from "../../Asserts/Electric.png";

function Header({ hero }) {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const isActive = (path) => location.pathname === path;
  const isSolutionsActive = location.pathname.startsWith("/solution");

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <>
      <header
        className={`header ${hero ? "header-hero" : ""} ${
          isScrolled ? "scrolled" : ""
        } ${isMenuOpen ? "menu-open" : ""}`}
      >
        <div className="header-container">
          {/* Logo Section */}
          <div className="logo-section">
            <div className="logo-wrapper">
              <img
                src={logo}
                className="logo-img"
                width="70"
                height="30"
                alt="Logo"
              />
            </div>
            <div className="logo-wrapper electric-logo">
              <img
                src={Electric}
                alt="Electric Logo"
                className="logo-img"
                width="70"
                height="30"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <ul className="nav-links">
              <li className={isActive("/") ? "active" : ""}>
                <Link to="/">Home</Link>
              </li>
              <li className={isActive("/about") ? "active" : ""}>
                <Link to="/about">About</Link>
              </li>
              <li
                className={`has-submenu ${isSolutionsActive ? "active" : ""}`}
              >
                <Link to="/solution" className="solution-link">
                  Solutions
                </Link>
                {/* Desktop submenu */}
                <ul className="submenu">
                  <li>
                    <Link to="/solution#mep">MEP Offering</Link>
                  </li>
                  <li>
                    <Link to="/solution#solar">Solar Offering</Link>
                  </li>
                  <li>
                    <Link to="/solution#panels">
                      Electrical & Automation Panels
                    </Link>
                  </li>
                  <li>
                    <Link to="/solution#asset">Asset Management</Link>
                  </li>
                </ul>
              </li>
              <li className={isActive("/gallery") ? "active" : ""}>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li className={isActive("/contact") ? "active" : ""}>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span
              className={`hamburger-line ${isMenuOpen ? "line-1" : ""}`}
            ></span>
            <span
              className={`hamburger-line ${isMenuOpen ? "line-2" : ""}`}
            ></span>
            <span
              className={`hamburger-line ${isMenuOpen ? "line-3" : ""}`}
            ></span>
          </button>

          {/* Mobile Navigation */}
          <div className={`mobile-nav ${isMenuOpen ? "open" : ""}`}>
            <ul className="mobile-nav-links">
              <li className={isActive("/") ? "active" : ""}>
                <Link to="/">Home</Link>
              </li>
              <li className={isActive("/about") ? "active" : ""}>
                <Link to="/about">About</Link>
              </li>
              <li className={isSolutionsActive ? "active" : ""}>
                <Link to="/solution" className="solution-link">
                  Solutions
                </Link>
                {/* Mobile submenu */}
                <ul className="mobile-submenu">
                  <li>
                    <Link to="/solution#mep">MEP Offering</Link>
                  </li>
                  <li> 
                    <Link to="/solution#solar">Solar Offering</Link>
                  </li>
                  <li>
                    <Link to="/solution#panels">
                      Electrical & Automation Panels
                    </Link>
                  </li>
                  <li>
                    <Link to="/solution#asset">Asset Management</Link>
                  </li>
                </ul>
              </li>
              <li className={isActive("/gallery") ? "active" : ""}>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li className={isActive("/contact") ? "active" : ""}>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Overlay for mobile menu */}
          <div
            className={`mobile-overlay ${isMenuOpen ? "active" : ""}`}
            onClick={() => setIsMenuOpen(false)}
          ></div>
        </div>
      </header>
      {/* Spacer only for non-hero pages to prevent content going under fixed header */}
      {!hero && <div className="header-spacer"></div>}
    </>
  );
}

export default Header;